<div [formGroup]="formModel.formGroup()">
  <h3 class="my-5px mt-10px">{{ "newPassword.header" | translate }}</h3>
  <h4 class="color-gray f-w-normal my-5px">{{ "newPassword.subheader" | translate }}</h4>
  <div class="input-group mt-30px">
    <label>{{ "currentPassword" | translate }}</label>
    <sxw-password-input placeholder="placeholder.currentPassword" formControlName="oldPassword" theme="input-theme custom-theme">
    </sxw-password-input>
  </div>
  <div class="input-group mt-30px">
    <label>{{ "newPasswordLabel" | translate }}</label>
    <sxw-password-input placeholder="placeholder.newPassword" formControlName="newPassword" theme="input-theme custom-theme"> </sxw-password-input>
  </div>
  <div class="input-group mt-20px">
    <label>{{ "confirmPassword" | translate }}</label>
    <sxw-password-input placeholder="placeholder.confirmPassword" formControlName="confirmPassword" theme="input-theme custom-theme">
    </sxw-password-input>
  </div>
</div>
